<template>
  <div>
    <b-card header="Parâmetros">
      <b-row>
        <b-col cols="4">
          <b-form-group label="Protocolo">
            <b-input-group>
              <b-form-input
                v-model="filter.protocol"
                type="text"
                @change="onFilterChange"
              />
              <b-input-group-append>
                <b-button
                  variant="info"
                  title="Pesquisar"
                  @click="searchProtocol"
                  ><i class="fas fa-search" aria-hidden="true" />
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="*" class="ml-3">
          <b-button @click="clearParameters">Limpar</b-button>
        </b-col>
        <b-col cols="*" class="ml-2">
          <b-button @click="print"
            ><i class="fas fa-print" aria-hidden="true" /> Imprimir</b-button
          >
        </b-col>
      </b-row>
    </b-card>
    <b-card id="report">
      <span v-if="!results">Digite o protocolo e clique em Pesquisar</span>
      <template v-else>
        <h3>Total de visualizações: {{ results.length }}</h3>
        <b-table
          :fields="[
            {
              key: 'createdAt',
              label: 'Data de Visualização',
            },
          ]"
          :items="results"
        >
          <template #cell(createdAt)="row">
            {{ row.item.createdAt | datetime }}
          </template>
        </b-table>
      </template>
    </b-card>
  </div>
</template>

<script>
import { getProtocolLogs } from "../../api/protocol";

export default {
  name: "ProtocolViewReport",
  data() {
    return {
      printing: false,

      filter: {
        protocol: null,
      },
      currentFilter: {
        protocol: null,
      },
      results: null,
      hcfg: { language: "pt", largest: 3 },
    };
  },
  methods: {
    clearParameters() {
      this.filter.protocol = null;
      this.currentFilter = {
        protocol: null,
      };
    },
    onFilterChange() {
      this.currentFilter.protocol = this.filter.protocol;
    },

    print() {
      // Pass the element id here
      this.printing = true;
      this.$htmlToPaper("report", () => {
        this.printing = false;
        console.log("Printing done or got cancelled!");
      });
    },

    async searchProtocol() {
      try {
        const response = await getProtocolLogs(this.currentFilter.protocol);
        this.results = response.data;
      } catch (error) {
        if (error.response.data) {
          this.$bvToast.toast(error.response.data, {
            title: "Erro",
            toastClass: "custom-toast custom-toast-error",
            variant: "light",
            solid: true,
            autoHideDelay: 10000,
            noCloseButton: false,
          });
        } else {
          this.$bvToast.toast(error.response.statusText, {
            title: "Erro",
            toastClass: "custom-toast custom-toast-error",
            variant: "light",
            solid: true,
            autoHideDelay: 10000,
            noCloseButton: false,
          });
        }
      }
    },
  },
};
</script>
